import type { AirBookingFlightItinerarySlice } from "@b2bportal/air-booking-api";
import type { Slice } from "@b2bportal/air-shopping-api";
import { FlightExchangeSliceDetailsCard } from "@b2bportal/core-flights";
import { useFlightStyles, useModuleBEM } from "@b2bportal/core-themes";
import { CoreFlightsComponent, SliceDirection } from "@b2bportal/core-types";
import { useFlightExchangeTripDetailsCard } from "./useFlightExchangeTripDetailsCard";

export type FlightExchangeTripDetailsCardProps = {
  className?: string;
  updateBadgeCopyOverride?: String;
};

export const FlightExchangeTripDetailsCard = (
  props: FlightExchangeTripDetailsCardProps
) => {
  const { context } = useFlightExchangeTripDetailsCard(props);
  const COMPONENT_KEY = CoreFlightsComponent.FlightExchangeTripDetailsCard;
  const styles = useFlightStyles(COMPONENT_KEY);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const sliceCard = (
    slice: AirBookingFlightItinerarySlice | Slice,
    direction: SliceDirection
  ) => {
    const isUpdated =
      (direction === SliceDirection.Outbound &&
        context.slices.outboundChanged) ||
      (direction === SliceDirection.Return && context.slices.returnChanged);

    return (
      <FlightExchangeSliceDetailsCard
        className={cn("slice-summary")}
        slice={slice}
        airportMap={context.airportMap}
        updateBadgeCopyOverride={context.updateBadgeCopyOverride}
        isUpdated={isUpdated}
        itinerary={context.updatedItinerary!}
        sliceDirection={direction}
      />
    );
  };

  const outboundCard =
    context.slices.outbound &&
    sliceCard(context.slices.outbound, SliceDirection.Outbound);

  const returnCard =
    context.slices.return &&
    sliceCard(context.slices.return, SliceDirection.Return);

  return (
    <ol className={cn("slice-list")}>
      {outboundCard == null ? null : (
        <li className={cn("slice-summary-li")}>{outboundCard}</li>
      )}
      {returnCard == null ? null : (
        <li className={cn("slice-summary-li")}>{returnCard}</li>
      )}
    </ol>
  );
};
